export default __webpack_public_path__ + "static/media/chemistry-card-bg.87f2693b.svg";